
window.$ = window.jQuery = $;

$(document).ready(function () {


	// Retrieves shipping address when another is selected.
	$(document).on('change', '#shipping_address_book_field input[name="shipping_address_book"]', function () {
		checkout_field_prepop(true)
	});

	// Update checkout when address changes
	if ($("form[name=checkout]").length > 0) {
		$('#shipping_country, #shipping_city, #shipping_postcode').on('change', function () {
			$(document.body).trigger('update_checkout');
		});
	};
});



/*
* AJAX call display address on checkout when selected.
*/
function checkout_field_prepop(initial_address) {


	let that = $('#shipping_address_book_field input[name="shipping_address_book"]:checked');


	let name = $(that).val();


	if (name !== undefined && name !== null) {

		if ('add_new' === name) {

			// Clear values when adding a new address.
			$('.woocommerce-shipping-fields__field-wrapper input').not($('#shipping_country')).not('#shipping_address_book').not('[name="shipping_address_book"]').each(function () {
				var input = $(this);
				if (input.attr("type") === "checkbox" || input.attr("type") === "radio") {
					input.prop("checked", false);
				} else {
					input.val('');
				}
			});
			$('.woocommerce-shipping-fields__field-wrapper select').not($('#shipping_country')).not('#shipping_address_book').each(function () {
				var input = $(this);
				if (input.hasClass('selectized') && input[0] && input[0].selectize) {
					input[0].selectize.setValue("");
				} else {
					input.val("").trigger('change');
				}
			});

			return;
		}


		if (name.length > 0) {

			console.log("12345RESTDYFUGIHOJKPL£");

			$.ajax({
				url: mm_address_book_apiurl.ajax_url,
				type: 'post',
				data: {
					action: 'wc_address_book_checkout_update',
					name: name,
					type: 'shipping',
					nonce: mm_address_book_apiurl.checkout_security,
				},
				dataType: 'json',
				success: function (response) {

					Object.keys(response).forEach(function (key) {
						let input = $('#' + key);
						if (input.length > 0) {
							if (mm_address_book_apiurl.allow_readonly !== "no" || input.attr('readonly') !== 'readonly') {
								if (input.is("select")) {
									if (input.hasClass('selectized') && input[0] && input[0].selectize) {
										input[0].selectize.setValue(response[key]);
									} else {
										input.val(response[key]).trigger('change');
									}
								} else if (input.attr("type") === "checkbox") {
									input.prop('checked', response[key] === "1").trigger('change');
								} else {
									input.val(response[key]).trigger('change');
								}
							}
						} else {
							// Handle radio buttons.
							let radio_field = $('#' + key + '_field');
							if (radio_field.length > 0) {
								radio_field.find("input[type='radio']").each(function (index, radio_button) {
									if ($(radio_button).val() === response[key]) {
										$(radio_button).prop('checked', true).trigger('change');
									}
								});
							}
						}
					});
				}
			});
		}
	}
}